import { mapGetters } from "vuex"

export default {
  methods: {
    handleJumpAdvDetail(appJump) {
      if (!appJump) return
      const nfPlusLinkReg = /^[a-z]+:\/\//i
      const reg = /^https?:\/\//i
      if (this.systemInfo.isNfPlus) {
        const isNfPlusLink = nfPlusLinkReg.test(appJump.jumpUrl)
        const isOutSideLink = reg.test(appJump.shareUrl)
        if (isNfPlusLink) {
          window.location.href = appJump.jumpUrl
        } else if (isOutSideLink) {
          window.location.href = appJump.shareUrl
          // this.$router.push({ path: "linkIframe", query: { linkSrc: appJump.shareUrl } })
        }
      } else {
        const isOutSideLink = reg.test(appJump.shareUrl)
        isOutSideLink && (window.location.href = appJump.shareUrl)
        // isOutSideLink && this.$router.push({ path: "linkIframe", query: { linkSrc: appJump.shareUrl } })
      }
    }
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo"
    })
  }
}
